/**
* @Author: zachalam
* @Date:   2017-02-15T14:12:47-08:00
* @Email:  zach@reflexmedia.com
* @Last modified by:   zachalam
* @Last modified time: 2017-02-15T14:12:47-08:00
*/

export const clearEverything = () => {
  return {
    type: 'CLEAR_EVERYTHING'
  }
}

export const clearErrors = () => {
  return {
    type: 'CLEAR_ERRORS',
  }
}

export const storeErrors = (payload) => {
  return {
    type: 'STORE_ERRORS',
    payload
  }
}

export const storeSpecificErrors = (name,payload) => {
  return {
    type: 'STORE_SPECIFIC_ERRORS',
    name,
    payload
  }
}

/** sets or removes load status **/
export const setLoading = () => {
  return {
    type: 'IS_FETCHING'
  }
}



// WEBPACK FOOTER //
// ./src/actions/commonActions.js